module.exports = __webpack_public_path__ + "assets/images/gender_female.7b6edd5c8edd9abe50babc566e65815a.svg";